import React, {useEffect, useState} from 'react';
import {Navigate, useLocation} from 'react-router-dom';
import axios from "axios";
import {connect} from "react-redux";

import LoadingSpinner from "../components/LoadingSpinner";
import {getJSONAcceptAuthConfig, USER_APPLICATIONS_ENDPOINT, WORKSHOPS_INFO_ENDPOINT} from "../api/api";
import {checkProfileForWorkshop} from "../utils/profileValidation"; // Импортируем утилиту

function CanCreateApplication({children, user}) {
    const location = useLocation();
    const [applicationData, setApplicationData] = useState(null);
    const [activeWorkshop, setActiveWorkshop] = useState(null);

    useEffect(() => {
        Promise.all([
            axios
                .get(WORKSHOPS_INFO_ENDPOINT, {
                    params: {is_active: "True"},
                    headers: getJSONAcceptAuthConfig().headers,
                })
                .then(response => {
                    setActiveWorkshop(response.data[0]);
                })
                .catch(error => {
                    console.error('Error getting active workshop data:', error);
                }),
            axios
                .get(USER_APPLICATIONS_ENDPOINT, {
                    params: {is_active: "True"},
                    headers: getJSONAcceptAuthConfig().headers,
                })
                .then(response => {
                    setApplicationData(response.data[0]?.cv);
                })
                .catch(error => {
                    console.error('Error getting application data:', error);
                })
        ]);
    }, []);

    if (!user || applicationData === null || activeWorkshop === null) {
        return <LoadingSpinner/>;
    }

    let workshopYear = 2026;

    if (activeWorkshop) {
        if (activeWorkshop.year) {
            workshopYear = activeWorkshop.year;
        }
        else if (activeWorkshop.start_date) {
            const startDate = new Date(activeWorkshop.start_date);
            if (!isNaN(startDate.getTime())) {
                workshopYear = startDate.getFullYear();
            }
        }
        else if (activeWorkshop.name) {
            const yearMatch = activeWorkshop.name.match(/\b(20\d{2})\b/);
            if (yearMatch) {
                workshopYear = parseInt(yearMatch[1]);
            }
        }
    }

    const { isValid, message } = checkProfileForWorkshop(user, workshopYear);

    if (applicationData?.participant || !activeWorkshop?.workers_can_apply) {
        return <Navigate to='/account/application' state={{from: location}} replace={true}/>;
    }

    if (workshopYear >= 2026 && !isValid) {
        return (
            <div>
                <h3 className="mb-2">Подача заявки на участие</h3>
                <hr className="clearfix w-100 pb-0"/>
                <div className="alert alert-warning">
                    {message}
                    <br />
                    <a href="/account/settings">Перейти к редактированию профиля</a>
                </div>
            </div>
        );
    }

    return children;
}

const mapStateToProps = state => ({
    user: state.auth.user,
});

export default connect(mapStateToProps)(CanCreateApplication);